import gtag, { install } from 'ga-gtag'
import qs from 'qs'
export const token = document.querySelector('meta[name="csrf-token"]').getAttribute('content')

let ga_id
if (document.querySelector('meta[name="ga_id"]')) {
  ga_id = document.querySelector('meta[name="ga_id"]').getAttribute('content')
  install(ga_id)
}

// ヘッダーボタンの挙動追加
const setHeaderButtonAction = () => {
  $('#button-menu,#button-search').on('click', function () {
    var parentObj = $(this).parent()

    if (parentObj.hasClass('open')) {
      parentObj.removeClass('open')
      $('html').removeClass('active')
    } else {
      if ($(this).closest('header').find('.open')) {
        $(this).closest('header').find('.open').removeClass('open')
        $('html').removeClass('active')
      }
      parentObj.addClass('open')
      $('html').addClass('active')
    }
  })
}

// pagetopのスクロール
const setPagetopAction = () => {
  $('.page-top').on('click', function () {
    $('body,html').animate({ scrollTop: 0 }, 400, 'swing')
  })
}

export const setPlayVideoEvent = pathname => {
  gtag('event', 'play', { 'event_category': 'video', 'event_label': pathname })
}

// fetch action
export const submitFetch = async (path, type, data = null, params = {}) => {
  let send = Object.assign({}, params, {
    method: type == "GET" ? "GET" : "POST",
    credentials: 'same-origin',
    headers: {
      'X-CSRF-TOKEN': token
    },
  })
  switch (type) {
    case 'GET':
      if (data) {
        let bodyStringify = qs.stringify(data)
        path = `${path}?${bodyStringify}`
      }
      break
    default:
      let formData = new FormData()
      for (let key in data) {
        formData.append(key, data[key]);
      }
      if (type == "PUT" || type == "PATCH" || type == "DELETE") {
        formData.append('_method', type)
      }
      Object.assign(send, { body: formData })
  }

  let resp = await fetch(path, send)
  return resp.json()
}

/**
 * スクロール時にヘッダーを非表示、上に戻るときに表示するアクション
 */
const headerScrollAction = () => {
  let headerDom = $('#main-header')
  let showFlag = true
  let positionCurrent = 0
  let headerDomH = 70
  headerDom.removeClass('hide')

  $(window).scroll(() => {
    const positionDiff = positionCurrent - $(window).scrollTop()
    positionCurrent = $(window).scrollTop()
    if (positionCurrent > headerDomH) {
      if ((positionDiff > 0 && positionCurrent > headerDomH)) {
        if (!showFlag) {
          headerDom.addClass('fixed')
          headerDom.removeClass('hide')
          showFlag = true
        }
      } else {
        if (showFlag && !$('.menu').hasClass('open')) {
          headerDom.addClass('hide')
          showFlag = false
        }
      }
    } else {
      headerDom.removeClass('fixed')
      headerDom.removeClass('hide')
    }
  })
}


const main = () => {
  setHeaderButtonAction()
  //headerScrollAction()
  setPagetopAction()
}
export default main